import { WorkOrderChangeStatusEnum } from 'gql/graphql';
import type { BadgePropStatus, BadgePropSize } from 'uikit';
import { Badge } from 'uikit';

import type { CSSProperties } from 'react';

import Styles from './WorkOrderChange.module.css';

export const statusProps: Record<WorkOrderChangeStatusEnum, { label: string; status: BadgePropStatus }> = {
    [WorkOrderChangeStatusEnum.OnFormation]: { label: 'На формировании', status: 'normal' },
    [WorkOrderChangeStatusEnum.Approving]: {
        label: 'На согласовании',
        status: 'approving' as BadgePropStatus,
    },
    [WorkOrderChangeStatusEnum.Approved]: { label: 'Согласован', status: 'success' },
};

export const WorkOrderChangeStatus = ({
    statusKey,
    isMinified = false,
    style,
    size,
}: {
    statusKey: WorkOrderChangeStatusEnum;
    isMinified?: boolean;
    style?: CSSProperties;
    size?: BadgePropSize;
}) => (
    <Badge className={Styles[statusKey]} {...statusProps[statusKey]} minified={isMinified} style={style} size={size} />
);

WorkOrderChangeStatus.displayName = 'WorkOrderChangeStatus';
